import i18next from 'i18next';
import debounce from 'lodash.debounce';

import Button from 'components/button';
import { selectedProductSelector } from 'selectors';
import { useAppDispatch, useAppSelector } from 'storeHooks';

import submitOrder from './orderSubmit.thunk';

const title = (symbol: string) => i18next.t('trading:lookingToClosePosition', { symbol });
const description = (symbol: string) =>
  i18next.t('trading:allOpenOrdersWillCancel', { symbol });
const confirmLabel = i18next.t('trading:confirm');
const cancelLabel = i18next.t('trading:cancel');

const ClosePositionConfirmation = ({
  handleModalClose,
}: {
  handleModalClose: () => void;
}) => {
  const dispatch = useAppDispatch();
  const selectedProduct = useAppSelector(selectedProductSelector);

  const handleSubmit = debounce(() => {
    dispatch(submitOrder());
  }, 400);

  return (
    (<div
      data-testid="close-position-confirmation-modal"
      data-palette="ClosePositionConfirmation">
      <h5 data-testid="close-position-title">{title(selectedProduct?.symbol ?? '')}</h5>
      <p data-testid="close-position-description">
        {description(selectedProduct?.symbol ?? '')}
      </p>
      <div className="d-flex justify-content-center">
        <Button
          data-testid="close-position-confirm-button"
          className="col-10 col-md-8 me-4"
          onClick={handleSubmit}
        >
          {confirmLabel}
        </Button>
        <Button
          data-testid="close-position-cancel-button"
          className="col-10 col-md-8"
          onClick={handleModalClose}
        >
          {cancelLabel}
        </Button>
      </div>
    </div>)
  );
};

export default ClosePositionConfirmation;
